import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importhistoryApi = createApi({
  reducerPath: "importhistoryApi",
  baseQuery,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("userToken");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-Request-Id", crypto.randomUUID());
    return headers;
  },
  tagTypes: ["importhistory"],
  endpoints: (builder) => ({
    getHistory: builder.query({
      query: ({ id}) =>
        `import/history/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item, index) => ({
          ...item,
          SrNo: index + 1,
          id: item.importHistoryId, 
        }));

      },
      providesTags: ["importhistory"],
    }),
  }),
});

export const {
  useLazyGetHistoryQuery,

} = importhistoryApi;
